export const css = {
	root: 'JP88AI2t',
	' _key': 'ascm-theme/dojo/grid-body'
};

export default css;
